var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"deep-purple","dark":""}},[_c('v-toolbar-title',[_vm._v("sourd")])],1),_c('v-main',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('IngredientsGrid')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }